import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import PropertyDetails from "../components/PropertyDetails";
import Listings from "../views/Listings";
import DataInsights from '../views/DataInsights.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/properties',
        name: 'Listings',
        component: Listings
    },
    {
        path: '/properties/details/:id?',
        name: 'PropertyDetails',
        component: PropertyDetails
    },
    {
        path: '/data-insights',
        name: 'DataInsights',
        component: DataInsights
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

export default router
